import { Tag } from 'antd'

import {
  DepositStatus,
  DepositStatusColorMap,
  DepositStatusTextMap
} from '@eastcoal/shared/enums/DepositStatus'

import { AuctionListDepositRenderProps } from './interface'

export const AuctionListDepositRender = ({
  record: { depositStatus = DepositStatus.NOT_PAY }
}: AuctionListDepositRenderProps) => {
  return (
    <Tag color={DepositStatusColorMap[depositStatus]} variant='filled'>
      {DepositStatusTextMap[depositStatus]}
    </Tag>
  )
}
